import { v4 as uuidv4 } from 'uuid';

export const generateUserId = () => {
  return uuidv4();
};

